<template>
  <a :href="getJumpWikiDetailUrl(item.game.alias, item.game.id, item.id)" class="article-list-item" target="_blank">
    <!-- 用户 -->
    <div v-if="showUser && layout != 'row'" class="top-user-box">
      <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
      <div class="r-wrapper">
        <div class="username">{{ item.user.username }}</div>
        <div class="date">{{ item.updated_at | dateFromNow }}</div>
      </div>
    </div>
    <!-- 标题、描述、图片 -->
    <div :class="['flex-box', `${item.thumb.length ? 'has-img' : ''}`, `flex-${layout}`]">
      <div class="text-box">
        <div class="title">
          <span v-if="item.audit_state == -1" class="disabled-tag">禁</span>
          <i v-if="item.is_top" class="iconfont icon-zhiding"></i>
          <span :class="{ through: item.audit_state == -1 }" v-html="xss(item.title)"></span>
          <span class="updated_at">
            <img src="../../../assets/images/time_icon.png" alt="" class="updated_img">
            {{dayjs(item.updated_at * 1000).format('YYYY-MM-DD')}}
          </span>
        </div>
        <div class="desc" v-if="item.summary" v-html="xss(handleSummary(item.summary))"></div>
      </div>
      <div v-if="item.thumb.length" class="img-box">
        <template v-for="(img, index) in item.thumb.split(',')">
          <div v-if="layout == 'row' ? index < 1 : index < 3" :key="index" class="item">
            <img v-lazy="handleImgSize(img, 'list')" alt="" />
          </div>
        </template>
      </div>
    </div>
    <!-- 游戏、文章点赞评论 -->
    <div class="bottom-box" v-if="showInfo">
      <div class="l-box">
        <span v-if="layout == 'row'" class="user">
          <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
          <span>{{ item.user.username }}</span>
        </span>
        <a class="game-name">
          <img v-lazy="handleImgSize(item.game.icon, 'mini')" alt="" />
          {{ item.game.name }}
        </a>
        <!--        <div v-if="layout != 'row'" class="view-count"><i class="iconfont icon-yanjing"/>{{ item.view_count }}</div>-->
      </div>
      <!-- 版本 -->
      <div class="data-box" v-if="showVersion">
        <span>修改了{{ item.version }} 版本</span>
        <span>{{ dayjs(item.created_at * 1000).format("YYYY-MM-DD HH:mm:ss") }}</span>
      </div>
      <div class="data-box" v-else>
        <div><i class="iconfont icon-pinglun" /> {{ item.comment_count }}</div>
        <div><i class="iconfont icon-chayue"></i>{{ item.view_count }}</div>
      </div>
    </div>
  </a>
</template>

<script>
import dayjs from "dayjs";
import { getJumpWikiDetailUrl } from "../../../plugins/util";
export default {
  name: "userArticleListItem",
  mixins: [],
  props: {
    // 图片与标题布局  row, column
    layout: {
      type: String,
      default: "row"
    },
    item: {
      type: Object,
      default: () => {}
    },
    keyword: {
      type: String,
      default: ""
    },
    showUser: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    showVersion: {
      type: Boolean,
      default: false
    }
  },
  model: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    dayjs,
    getJumpWikiDetailUrl,
    onClick(e) {
      console.log("1");
      console.log(e);
      if (this.isUserHome) {
        console.log("2");
        e.stopPropagation();
        e.preventDefault();
        // let url = `//${this.item.game.alias}.gamekee.com/${this.item.id}.html`;
        // window.open(url);
      }
    },
    goPage(item) {
      if (this.device.inApp) {
        this.jsToApp("app_goDetail", JSON.stringify(item));
      } else {
        this.$router.push(`${item.game.alias}/${item.id}.html`);
      }
    },
    handleSummary(text) {
      let str = text;
      if (this.keyword) {
        let reg = new RegExp(`${this.keyword}`, "gim");
        str = text.replace(reg, '<span style="color:red;">' + this.keyword + "</span>");
      }
      return str;
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.article-list-item {
  border-bottom: 1px solid @border-basic;
  margin-bottom: 12px;
  padding-bottom: 12px;
  display: block;
  padding: 20px 28px;

  .top-user-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    img {
      width: 36px;
      height: 36px;
      object-fit: cover;
      border-radius: 50%;
    }

    .r-wrapper {
      padding-left: 10px;
      font-size: 12px;

      .username {
        max-width: 150px;
        color: #2f2f2f;
        font-weight: 500;
        line-height: 20px;
      }

      .date {
        color: #989898;
      }
    }
  }

  .flex-box {
    display: flex;

    &.flex-row {
      justify-content: space-between;

      .text-box {
        width: 100%;
      }

      &.has-img {
        .text-box {
          width: calc(100% - 110px);
        }
      }

      .img-box {
        width: 96px;
        height: 60px;

        img {
          width: 96px;
          height: 60px;
          border-radius: 6px;
          object-fit: cover;
        }
      }
    }

    &.flex-column {
      flex-direction: column;

      .img-box {
        display: flex;

        .item {
          margin-right: 8px;

          &:last-child {
            margin-right: 0;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
          }
        }

        @media screen and (max-width: 500px) {
          .item {
            width: calc((100% - 14px * 2) / 3);
            height: 90px;
          }
        }

        @media screen and (min-width: 500px) {
          .item {
            width: 140px;
            height: 90px;
            max-width: calc((100% - (14px * 2)) / 3);
          }
        }
      }
    }

    .text-box {
      cursor: pointer;

      .title {
        .ellipsis;
        position: relative;
        width: auto;
        font-size: 16px;
        color: #151515;
        line-height: 24px;
        text-align: justify;
        margin-bottom: 12px;
        font-weight: bold;
        .iconfont {
          font-size: 16px;
          margin-right: 5px;
          color: #e74957;
        }

        .disabled-tag {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: #ee1a3e;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
        }


        .updated_at {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: 0;
          top: 0;
          margin-left: 10px;
          font-size: 12px;
          color: #bcbcbc;
          .updated_img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }

        .through {
          text-decoration: line-through;
        }
      }

      .desc {
        font-size: 14px;
        color: #8b8b8b;
        line-height: 21px;
        overflow: hidden;
        max-height: 42px;
        margin-bottom: 16px;
      }
    }
  }

  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    color: #575757;
    font-size: 12px;

    .l-box {
      display: flex;
      align-items: center;

      .game-name {
        font-size: 12px;
        color: #666;
        background: @border-basic;
        border-radius: 20px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 22px;
        margin-right: 14px;

        img {
          width: 16px;
          height: 16px;
          border-radius: 2px;
          margin-right: 6px;
        }
      }

      .user {
        display: flex;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }
      }
    }

    .iconfont {
      margin-right: 4px;
      font-size: 12px;
    }

    div {
      display: flex;
      align-items: center;
    }

    .data-box {
      display: flex;
      align-items: center;
      color: #bcbcbc;
      > div {
        display: flex;
        align-items: center;
      }

      > div + div {
        margin-left: 12px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
